import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import RBTooltip from 'react-bootstrap/Tooltip';
import cx from 'classnames';

const Tooltip = ({
  content = '',
  display = 'd-inline-block',
  placement = 'bottom',
  reverse = false,
  customClass = null,
  children
}) => {
  const renderTooltip = (props) => (
    <RBTooltip
      {...props}
      className={cx(`custom-tooltip ${customClass}`, {reverse: reverse})}
    >
      {content}
    </RBTooltip>
  );

  return (
    <OverlayTrigger
      overlay={renderTooltip}
      trigger={['hover', 'focus']}
      placement={placement}
    >
      <div className={display}>{children}</div>
    </OverlayTrigger>
  );
}

export default Tooltip;
